import { UserMini } from "@infoland/iprova-api";
import { SubjectMini } from "./case";

export interface CaseTypePermission {
    /** The subject*/
    subject: SubjectMini;
    /** The role type */
    role_type: RoleType;
    /** List of users */
    users: UserMini[];
    /** List of user groups */
    user_groups: UserGroupMini[];
    /** List of teams */
    teams: TeamMini[];
    /** List of resolved users */
    resolved_users: UserMini[];
    /** First preffered user */
    first_preferred_user: UserMini;
    /** Second preffered user */
    second_preferred_user: UserMini;
}

export interface TeamMini {
    /** Id of the team*/
    team_id: Number;
    /** Name of the team */
    name: string;
}

export interface UserGroupMini {
    /** The id of the user group*/
    user_group_id: string;
    /** Name of the user group */
    name: string;
}

export enum RoleType {
    actor = "actor",
    coordinator = "coordinator"
}
